<template>
    <v-app>
        <v-toolbar app class="app-toolbar">
            <v-toolbar-title>Terms & Conditions</v-toolbar-title>
        </v-toolbar>
        <v-content pa-0>
            <v-container fluid fill-height>
                <v-layout>
                    <v-flex xs12 class="description">
                        <vas-terms/>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
        <v-footer app>
            <v-btn color="primary" flat small class="text-xs-right" @click="exit">
                Decline
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat small class="text-xs-right" @click="accept">
                Accept
            </v-btn>
        </v-footer>
        <v-dialog v-model="showTermsMessage" :persistent="true">
            <v-card>
                <v-card-text>
                    Please read the Terms &amp; Conditions till the end before continuing.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="showTermsMessage = false">
                        Okay
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showError" :persistent="true">
            <v-card>
                <v-card-text>
                    {{ errorMessage }}
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="showError = false">
                        Okay
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>
<script>
    import vas from "@/lib/VASClient"
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                showTermsMessage: false,
                termsRead: false,
                showError: false,
                errorMessage: ''
            }
        },
        methods: {
            handleScroll(event) {
                const el = document.scrollingElement || document.documentElement;

                if (document.documentElement.scrollHeight - el.scrollTop === document.documentElement.clientHeight) {
                    this.termsRead = true;
                }

                this.termsRead = true;
            },
            accept() {
                var self = this;

                if (!this.termsRead) {
                    this.showTermsMessage = true;

                    return;
                }

                Loading.show("Please wait");
                vas.acceptTerms(this.auth.user.user_id).then(function () {
                    var user = self.auth.user;
                    user.terms_accepted = "1";

                    self.$store.commit('auth/login', {
                        user: user,
                        remember: self.auth.remember,
                        name: self.auth.name
                    });

                    self.$router.push("/dashboard")

                    Loading.hide();
                }).catch(function (e) {
                    console.log(e);
                    self.showError = true;
                    self.errorMessage = 'An error has occurred. Please try again later';

                    Loading.hide();
                });

            },
            exit() {
                localStorage.setItem('user', null);
                localStorage.setItem('remember', null);
                localStorage.removeItem('user');
                localStorage.removeItem('remember');

                this.$store.dispatch('auth/logout');

                this.$router.push({name: 'unauthenticated.login'});
            }
        },
        beforeMount() {
            window.addEventListener('scroll', this.handleScroll);
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        computed: {
            ...mapState(
                ['auth']
            )
        }
    }
</script>
